import { apiClient } from '@/services/apiClient';

export const getTemplatesCategories = (rootId: string) => apiClient.get(`template-categories/${rootId}`);
export const getTemplatesByCategoryId = (rootCategoryId: string) =>
  apiClient.get(`templates/${rootCategoryId}/by-category-id`);
